import React, { useState } from 'react';
import { FormRow, Alert } from '.';
import { useAppContext } from '../context/appContext';
import { FaSun, FaMoon } from 'react-icons/fa';
import Wrapper from '../assets/wrappers/DashboardFormPage';

const ProfileInfo = () => {
  const {
    user,
    showAlert,
    displayAlert,
    updateUser,
    isLoading,
    toggleThemePreference,
    themePreference,
  } = useAppContext();
  const [name, setName] = useState(user?.name);
  const [email, setEmail] = useState(user?.email);
  const [lastName, setLastName] = useState(user?.lastName);
  const [location, setLocation] = useState(user?.location);

  const handleSubmit = (e) => {
    e.preventDefault();
    // remove while testing
    if (!name || !email || !lastName || !location) {
      displayAlert();
      return;
    }

    updateUser({ name, email, lastName, location });
  };

  const updateTheme = () => {
    toggleThemePreference(user._id);
  };

  return (
    <Wrapper>
      <div className='theme-preference' onClick={updateTheme}>
        {themePreference == 'light-mode' ? <FaMoon /> : <FaSun />}
      </div>
      <form className='form' onSubmit={handleSubmit}>
        <h3>profile</h3>
        {showAlert && <Alert />}
        <div className='form-center'>
          <FormRow
            type='text'
            name='name'
            value={name}
            handleChange={(e) => setName(e.target.value)}
          />
          <FormRow
            type='text'
            labelText='last name'
            name='lastName'
            value={lastName}
            handleChange={(e) => setLastName(e.target.value)}
          />
          <FormRow
            type='email'
            name='email'
            value={email}
            handleChange={(e) => setEmail(e.target.value)}
          />
          <FormRow
            type='text'
            name='location'
            value={location}
            handleChange={(e) => setLocation(e.target.value)}
          />
          <button className='btn btn-block' type='submit' disabled={isLoading}>
            {isLoading ? 'Please Wait...' : 'Save Changes'}
          </button>
        </div>
      </form>
    </Wrapper>
  );
};

export default ProfileInfo;
